import { CfHeroBlockProps } from "components/HeroBlock/CfHeroBlock/schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { MarkdownCheckList } from "components/MarkdownCheckList";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import HeroBlock, { HeroBlockProps } from "components/HeroBlock";
import Markdown from "react-markdown";
import React from "react";
import recursiveRender from "utilities/recursiveRender";

const convertCfHeroBlockProps = ({
  theme,
  iconImage,
  badgeType,
  title,
  titleSize,
  titleTag,
  price,
  description,
  checkList,
  listCta,
  node_locale,
  contentful_id,
}: CfHeroBlockProps): HeroBlockProps => {
  const liveInspector: LiveInspectorData = {
    heroBlock: ContentfulLivePreview.getProps({
      entryId: contentful_id,
      fieldId: "entryTitle",
    }),
  };

  const updatedDescription =
    typeof description === "string" ? description : description.description;

  const updatedCheckList =
    typeof checkList === "string" ? checkList : checkList?.checkList;

  return {
    theme,
    iconImage: iconImage ? iconImage.file.url : undefined,
    badgeType: badgeType || undefined,
    title,
    titleSize,
    TitleTag: titleTag,
    price: price || undefined,
    description: <Markdown>{updatedDescription}</Markdown>,
    checkList: updatedCheckList && (
      <MarkdownCheckList>{updatedCheckList}</MarkdownCheckList>
    ),
    listCta: recursiveRender({ cfComponent: listCta }),
    node_locale,
    liveInspector,
  };
};

const CfHeroBlock = (props: CfHeroBlockProps) => {
  const {
    iconImage: _,
    listCta: __,
    ...liveProps
  } = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  return <HeroBlock {...convertCfHeroBlockProps({ ...props, ...liveProps })} />;
};

export default CfHeroBlock;
